import React from 'react';
import qs from 'qs';
import { Link } from 'react-router-dom';

import styles from '../../pages/Archives/css/Archives.module.css';


const generateKey = (pre) => `${pre}_${new Date().getTime()}`;


class Pagination extends React.Component {
  constructor(props) {
    super(props);
    const { pathname } = window.location;
    this.baseURL = pathname;
    const { search } = window.location;
    this.parsedSearch = {};
    if (search) {
      this.parsedSearch = qs.parse(search, { ignoreQueryPrefix: true });
      delete this.parsedSearch.page;
      if (Object.keys(this.parsedSearch).length) {
        this.baseURL = `${this.baseURL}?${qs.stringify(this.parsedSearch)}`;
      }
    }
  }

  calculateLastPage = () => {
    const { totalNumber, entriesPerPage } = this.props;

    let numberOfPages = totalNumber / entriesPerPage;
    numberOfPages = numberOfPages.toString();
    const number = numberOfPages.split('.');

    return number[1] ? parseInt(number[0]) + 1 : parseInt(number[0]);
  };

  handlePageClick = (e) => {
    const {
      saveStateKeyParent,
      activePageNumber,
    } = this.props;
    const stateKeyName = 'currentPageNumber';

    // e.preventDefault();
    // e.stopPropagation();

    switch (e.currentTarget.text.toLowerCase()) {
      case '« first':
        saveStateKeyParent(stateKeyName, 1);
        break;
      case '‹ prev':
        saveStateKeyParent(stateKeyName, activePageNumber - 1);
        break;
      case 'next ›':
        saveStateKeyParent(stateKeyName, activePageNumber + 1);
        break;
      case 'last »':
        // total number / 8
        saveStateKeyParent(stateKeyName, this.calculateLastPage());
        break;
      default:
        saveStateKeyParent(
          stateKeyName,
          parseInt(e.currentTarget.text.toLowerCase())
        );
        break;
    }
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  };

  renderLinks = () => {
    const { activePageNumber } = this.props;
    const links = [];
    let obs = 0;
    const lastPage = this.calculateLastPage();
    const prefix = Object.keys(this.parsedSearch).length ? '&' : '?';

    if (activePageNumber >= 2) {
      links.push(
        <li key={generateKey('first_li')}>
          <Link
            key={generateKey('first_link')}
            className={styles.lastButton}
            to={`${this.baseURL}${prefix}page=1`}
            onClick={this.handlePageClick}
          >
            « First
          </Link>
        </li>
      );
      links.push(
        <li key={generateKey('prev_li')}>
          <Link
            key={generateKey('prev_link')}
            className={styles.lastButton}
            to={`${this.baseURL}${prefix}page=${activePageNumber - 1}`}
            onClick={this.handlePageClick}
          >
            &lt; Prev
          </Link>
        </li>
      );
    }

    if (activePageNumber > 5) {
      links.push(
        <li key={generateKey('dots_before_li')}>
          <Link
            key={generateKey('dots_before_a')}
            className="disabled"
            className={styles.paginationButton}
            to="#"
          >
            ...
          </Link>
        </li>
      );
    }

    if (activePageNumber < 5) {
      for (let i = 1; i <= (lastPage < 5 ? lastPage : 5); i++) {
        links.push(
          <li
            key={generateKey(`${i}_li`)}
            className={activePageNumber === i ? 'active' : ''}
          >
            <Link
              key={generateKey(`${i}_link`)}
              className={styles.paginationButton}
              to={`${this.baseURL}${prefix}page=${i}`}
              onClick={this.handlePageClick}
            >
              {i}
            </Link>
          </li>
        );
      }
    } else {
      for (let i = activePageNumber - 4; i <= activePageNumber; i++) {
        links.push(
          <li
            key={generateKey(`${i}_li`)}
            className={activePageNumber === i ? 'active' : ''}
          >
            <Link
              key={generateKey(`${i}_link`)}
              className={styles.paginationButton}
              to={`${this.baseURL}${prefix}page=${i}`}
              onClick={this.handlePageClick}
            >
              {i}
            </Link>
          </li>
        );
      }
    }

    if (activePageNumber >= 5 && activePageNumber < lastPage) {
      // activePageNumber + 1 : the current page was already displayed in the first for() {} so we start at '+1'
      for (let i = activePageNumber + 1; i <= lastPage; i++) {
        if (obs > 3) {
          break;
        }
        links.push(
          <li
            key={generateKey(`${i}_li`)}
            className={activePageNumber === i ? 'active' : ''}
          >
            <Link
              key={generateKey(`${i}_link`)}
              className={styles.paginationButton}
              to={`${this.baseURL}${prefix}page=${i}`}
              onClick={this.handlePageClick}
            >
              {i}
            </Link>
          </li>
        );
        ++obs;
      }
    }

    if (activePageNumber < lastPage - 4) {
      links.push(
        <li key={generateKey('dots_after_li')}>
          <Link
            key={generateKey('dots_after_link')}
            className="disabled"
            className={styles.lastButton}
            to="#"
          >
            ...
          </Link>
        </li>
      );
    }

    if (activePageNumber !== lastPage) {
      links.push(
        <li key={generateKey('next_li')}>
          <Link
            key={generateKey('next_link')}
            className={styles.nextButton}
            rel="next"
            to={`${this.baseURL}${prefix}page=${activePageNumber * 1 + 1}`}
            onClick={this.handlePageClick}
          >
            Next &gt;
          </Link>
        </li>
      );
      links.push(
        <li key={generateKey('last_li')}>
          <Link
            key={generateKey('last_link')}
            className={styles.lastButton}
            to={`${this.baseURL}${prefix}page=${lastPage}`}
            onClick={this.handlePageClick}
          >
            Last »
          </Link>
        </li>
      );
    }

    return links;
  };

  render() {
    return (
      <div className="pagnation-controls text-center">
        <ul className="pagination">
          {this.renderLinks().map((link) => link)}
        </ul>
      </div>
    );
  }
}

export default Pagination;
